import { useFirestore, useFirestoreCollectionData, useUser } from "reactfire";
import { addDoc, collection, doc, query, setDoc, where, serverTimestamp, Timestamp } from "firebase/firestore";
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Radio, RadioGroup, Select, SelectItem, Textarea, useDisclosure } from "@nextui-org/react";
import { useEffect, useState } from "react";
import { FileUpload } from "../../components/fileUpload";
import { FileType } from "../../types/types";
import { v4 as uuidv4 } from 'uuid';
import { time } from "console";
import { createJob } from "../../services/jobservice";

export const NewJob = () => {
    const firestore = useFirestore();
    const user = useUser();
    const newUploadFile: FileType = {
        id: "",
        path: "",
        name: "",
        downloadUrl: "",
        owner: user?.data?.uid || '',
        deleted: false
    }
    const [uploadedFile, setUploadedFile] = useState<FileType>(newUploadFile);
    const [name, setName] = useState<string>("");
    const [type, setType] = useState<string>("generator");
    const [target, setTarget] = useState<any>();

    const handleCreateJob = async (event: any) => {
        event?.preventDefault();
        const data = {
            createdBy: user?.data?.uid,
            type: type,
            targetId: target,
            file: uploadedFile,
            name: name,
            createdByName: user?.data?.displayName,
        }
        return createJob(firestore, data);
    }
    const { data: generators } = useFirestoreCollectionData(
        query(collection(firestore, 'generators'), where('createdBy', '==', user?.data?.uid)),
        { idField: 'id' }
    );
    const { data: extractors } = useFirestoreCollectionData(
        query(collection(firestore, 'extractors'), where('createdBy', '==', user?.data?.uid)),
        { idField: 'id' }
    );
    const { data: comparators } = useFirestoreCollectionData(
        query(collection(firestore, 'comparators'), where('createdBy', '==', user?.data?.uid)),
        { idField: 'id' }
    );

    useEffect(() => {
        if (type === 'generator' && generators && generators.length > 0) {
            setTarget(generators[0].id);
        }
        if (type === 'generator' && extractors && extractors.length > 0) {
            setTarget(extractors[0].id);
        }
        if (type === 'generator' && comparators && comparators.length > 0) {
            setTarget(comparators[0].id);
        }
    }, [comparators, extractors, generators, type]);

    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    return (
        <>
            <Button color="primary" onPress={onOpen}>New Job</Button>
            <Modal
                isOpen={isOpen}
                onOpenChange={onOpenChange}
                placement="top-center"
            >
                <form onSubmit={handleCreateJob}>

                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalHeader className="flex flex-col gap-1">New Job</ModalHeader>
                                <ModalBody>
                                    <RadioGroup
                                        label="Type of Job"
                                        orientation="horizontal"
                                        onChange={(e) => setType(e.target.value)}
                                    >
                                        <Radio value="generator">DoxGen</Radio>
                                        <Radio value="extractor">DoxEx</Radio>
                                        <Radio value="comparator">DocComp</Radio>
                                    </RadioGroup>
                                    {type === "generator" ? (
                                        <Select
                                            items={generators}
                                            name="runnerId"
                                            label="Generator"
                                            isRequired
                                            selectedKeys={[target]}
                                            onChange={(e) => setTarget(e.target.value)}
                                        >
                                            {(generator) => <SelectItem key={generator.id} value={generator.name}>{generator.name}</SelectItem>}

                                        </Select>
                                    ) : <></>}
                                    {type === "extractor" ? (
                                        <Select
                                            items={extractors}
                                            name="runnerId"
                                            label="Extractor"
                                            isRequired
                                            selectedKeys={[target]}
                                            onChange={(e) => setTarget(e.target.value)}
                                        >
                                            {(extractor) => <SelectItem key={extractor.id} value={extractor.name}>{extractor.name}</SelectItem>}

                                        </Select>
                                    ) : <></>}
                                    {type === "comparator" ? (
                                        <Select
                                            items={comparators}
                                            name="runnerId"
                                            label="Comparator"
                                            isRequired
                                            selectedKeys={[target]}
                                            onChange={(e) => setTarget(e.target.value)}
                                        >
                                            {(comparator) => <SelectItem key={comparator.id} value={comparator.name}>{comparator.name}</SelectItem>}

                                        </Select>
                                    ) : <></>}
                                    <Input
                                        autoFocus
                                        isRequired
                                        label="Name"
                                        name="name"
                                        placeholder="Provide a Name"
                                        variant="bordered"
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                    <FileUpload fileObj={uploadedFile}
                                        handleUpload={(newUploadedFile) => setUploadedFile(newUploadedFile)}
                                        handleDelete={() => { }} />
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" variant="flat" onPress={onClose}>
                                        Close
                                    </Button>
                                    <Button color="primary" onClick={onClose} type="submit">
                                        Run
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </form>
            </Modal>
        </>
    )
}